import { useHistory } from 'react-router';
import { Flex } from 'components/base/layout-components';
import { SidebarButton } from '@linearb/linui-common';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';

const SidebarButtons = ({
  sidebarButtons,
  sidebarExpanded,
  anchorEl,
  setAnchorEl,
  menuItems,
  setMenuItems,
  clicked = {},
  setClicked
}) => {
  const history = useHistory();
  const { getSelectedSidebarItemByPath, isSidebarPinned } = useSidebarState();
  const selected = getSelectedSidebarItemByPath(sidebarButtons);

  const resetSidebarState = () => {
    setAnchorEl();
    setClicked({});
  };

  const handleButtonClick = (
    event,
    id,
    path,
    search,
    iconColorPalette,
    menu,
    anchorOrigin,
    transformOrigin,
    style,
    isBorderTop
  ) => {
    setAnchorEl(event.currentTarget);
    if (path && !clicked.id) {
      history.push({
        pathname: path,
        search
      });
      resetSidebarState();
    }

    if (clicked?.id) {
      resetSidebarState();
    }

    if (menu?.length) {
      if (clicked.id) {
        resetSidebarState();
      } else {
        setClicked({
          id,
          path,
          colorPalette: iconColorPalette,
          menu,
          anchorOrigin,
          transformOrigin,
          style,
          isBorderTop
        });
        setMenuItems(menu);
      }
    }
  };

  return (
    <>
      <Flex direction='column' width='100%'>
        {sidebarButtons.map(
          ({
            id,
            title,
            icon,
            path,
            search,
            iconColorPalette,
            menu = [],
            anchorOrigin = {
              vertical: 'top',
              horizontal: 'right'
            },
            transformOrigin = {
              vertical: 'top',
              horizontal: 'left'
            },
            style,
            isBorderTop
          }) => {
            const noItemsInMenu =
              menu.length &&
              menu.every(({ type }) => type === 'title' || type === 'subtitle');

            if (noItemsInMenu) {
              return null;
            }

            return (
              <SidebarButton
                key={id}
                icon={icon}
                title={title}
                iconColorPalette={iconColorPalette}
                isExpanded={sidebarExpanded}
                isSidebarPinned={isSidebarPinned}
                disabledHover={!!clicked?.id}
                onClick={e => {
                  handleButtonClick(
                    e,
                    id,
                    path,
                    search,
                    iconColorPalette,
                    menu,
                    anchorOrigin,
                    transformOrigin,
                    style,
                    isBorderTop
                  );
                }}
                isClicked={id === clicked.id}
                isSelected={id === selected.buttonId}
              />
            );
          }
        )}
      </Flex>
    </>
  );
};

export default SidebarButtons;
